/**
 * debug log level name
 * @type {String}
 */
export const DEBUG = 'debug';

/**
 * verbose log level name
 * @type {String}
 */
export const VERBOSE = 'verbose';

/**
 * info log level name
 * @type {String}
 */
export const INFO = 'info';

/**
 * warn log level name
 * @type {String}
 */
export const WARN = 'warn';

/**
 * error log level name
 * @type {String}
 */
export const ERROR = 'error';

/**
 * critical log level name
 * @type {String}
 */
export const CRITICAL = 'critical';

/**
 * A level higher than all levels. Used to silence even critical messages
 * @type {String}
 */
export const SILENT = 'silent';

/**
 * List of log levels (by severity)
 * @type {Array}
 */
export const LEVELS = [ DEBUG, VERBOSE, INFO, WARN, ERROR, CRITICAL ];

/**
 * List of log levels (by severity)
 * @type {Array}
 */
export const LEVELS_SCALE = [ DEBUG, VERBOSE, INFO, WARN, ERROR, CRITICAL, SILENT ];

/**
 * Convert log level (name) to severity (int). Complies with Coralogix severity levels
 * @see https://coralogix.com/integrations/coralogix-rest-api/
 * @param  {String} level
 * @return {Number}
 */
export const severity = (level) => LEVELS.indexOf(level) + 1;
